import React from 'react';
import Dialog from './OleDialog';

interface ErrorDialogProps {
  isOpen: boolean;
  error: {
    title: string;
    subtitle: string;
    buttonText: string;
  } | null;
  onClose: () => void;
  onButtonClick: () => void;
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({ isOpen, error, onClose, onButtonClick }) => {
  if (!isOpen || !error) return null;

  return (
    <Dialog
      title={error.title}
      subtitle={error.subtitle}
      buttonText={error.buttonText}
      showClose={false}
      onClose={onClose}
      onButtonClick={onButtonClick}
    />
  );
};

export default ErrorDialog;
